export const editOffSvg = (props = {}) => {
  return (
    <svg
      fill="#fff"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.85378 2.14645C2.65853 1.95118 2.34195 1.95118 2.14669 2.14645C1.95143 2.34171 1.95143 2.65829 2.14669 2.85355L7.67745 8.3844L3.63936 12.4232L3.5221 12.5511C3.33644 12.7722 3.20037 13.0314 3.12406 13.3112L2.01817 17.3662L2.00301 17.4455C1.96546 17.7861 2.28552 18.0746 2.6321 17.9801L6.68701 16.8742L6.85229 16.8213C7.12316 16.7215 7.36989 16.564 7.57498 16.3589L11.6132 12.3202L17.1465 17.8536C17.3417 18.0488 17.6583 18.0488 17.8536 17.8536C18.0488 17.6583 18.0488 17.3417 17.8536 17.1464L2.85378 2.14645ZM15.6128 8.32028L13.0274 10.9059L9.09154 6.97005L11.6769 4.38427L15.6128 8.32028ZM13.245 2.81738C14.3318 1.73057 16.0939 1.73057 17.1807 2.81738C18.2222 3.8589 18.2656 5.52058 17.3108 6.61379L17.1807 6.75306L16.3198 7.61328L12.3838 3.67727L13.245 2.81738Z"
        fill="#212121"
      />
    </svg>
  );
};
